import ClashModelManager from "../Data/DataManagers/ClashModelManager.js";
import { getElementById } from "../Experience/World/CustomHighlighter.js";
import Experience from "../Experience/Experience.js";
import Threejsfunctions from "../Experience/Threejs/ThreeJSFunctions.js";
import { handleElementSelect } from "../Experience/World/CustomHighlighter.js";
import { handleElementDeselect } from "../Experience/World/CustomHighlighter.js";
import { asyncFitOrthoPerCameraToCenteredObject } from "../Experience/Threejs/ThreeJSFunctions.js";
import { setMeshOpacity } from "../Experience/IFC/IFCMeshHandler.js";


const clashmodelManager = new ClashModelManager();
let experience = null;

let selectedConstructionUUID = null;
let previouslyHiddenMeshes = new Set();

export function resetSelectedConstructionUUID(){
    selectedConstructionUUID = null;

}

export function resetAllMeshVisibility(scene) {
    scene.traverse((object) => {
        if (object.isMesh) {
            object.visible = true;
        }
    });
    previouslyHiddenMeshes.clear();
}

function isolateMeshes(keepVisibleSet, scene) {
    previouslyHiddenMeshes.clear();

    scene.traverse((object) => {
        if (object.isMesh) {
            const shouldBeVisible = keepVisibleSet.has(object);
            object.visible = shouldBeVisible;

            if (!shouldBeVisible) {
                previouslyHiddenMeshes.add(object);
            }
        }
    });
}

function onMagnifyClick(construction, installations, scene) {

    console.log(installations)
    const isSameConstruction = selectedConstructionUUID === construction.meshuuid;

    if (isSameConstruction) {
        // Deselect
        resetAllMeshVisibility(scene);
        selectedConstructionUUID = null;
        return;
    }

    // New selection
    const keepVisible = new Set([construction.mesh]);
    installations.forEach(({installation, clash }) => 
        {
            console.log("inst", installation)
            console.log("clash", clash)
            keepVisible.add(installation.mesh), 
            keepVisible.add(clash.mesh)
        });

    isolateMeshes(keepVisible, scene);
    selectedConstructionUUID = construction.meshuuid;

    Threejsfunctions.fitOrthoPerCameraToCenteredObject(experience.world.world.camera, construction.mesh);


    // Optionally add zoom-to logic here
}


export function showClashOverviewPanel() {
    if (!experience) {
        experience = new Experience();
    }

    const panel = document.getElementById("clashOverviewPanel");

    // Toggle panel display
    if (panel.style.display === "block") {
        panel.style.display = "none";
        resetAllMeshVisibility(experience.world.world.scene.three); // Reset visibility on close
        selectedConstructionUUID = null;
        return;
    }

    panel.style.display = "block";

    updateClashOverviewTable();
}

function updateClashOverviewTable() {
    const clashnum = clashmodelManager.getNumberofClashes();
    document.getElementById("clashOverviewName").textContent = "Clash Overview: " + clashnum + " clashes";

    const tableBody = document.querySelector("#clashOverviewTable tbody");
    tableBody.innerHTML = "";

    const models = clashmodelManager.getClashListGroupedByConstruction();
    const scene = experience.world.world.scene.three;

    models.forEach(({ construction, installations}) => {
        
        const headerRow = document.createElement("tr");
        const headerCell = document.createElement("td");
        headerCell.colSpan = 2;
        headerCell.classList.add("clashParameter-header");

        const toggleButton = document.createElement("button");
        toggleButton.classList.add("clashcollapse-toggle");
        toggleButton.setAttribute("aria-expanded", "false");

        toggleButton.innerHTML = `
            <span class="clasharrow-icon">&#9654;</span>
            <span class="clashtruncate">${construction.category}: ${construction.name}</span>
            <span class="installation-count">(${installations.length})</span>
            <span class="magnify-icon" title="Zoom to element">
                <i class="fa-solid fa-magnifying-glass"></i>
            </span>
        `;

        headerCell.appendChild(toggleButton);
        headerRow.appendChild(headerCell);
        tableBody.appendChild(headerRow);

        // Collapse/expand installation list
        const installationContainer = document.createElement("tbody");
        installationContainer.classList.add("clashParameter-container");
        installationContainer.style.display = "none";

        installations.forEach(({ installation, clash }) => {
            const row = document.createElement("tr");
            row.classList.add("installation-row");
            row.style.cursor = "pointer";

            const cell = document.createElement("td");
            const wrapper = document.createElement("div");
            wrapper.style.display = "flex";
            wrapper.style.alignItems = "center";
            wrapper.style.gap = "6px";

            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.classList.add("installation-checkbox");
            checkbox.checked = clash.isclash;
            // Optional: toggle installation.isclash when checkbox is changed
            checkbox.addEventListener("change", (e) => {
                clash.isclash = e.target.checked;
                console.log(`${installation.name} clash status:`, clash.isclash);
            });

            const label = document.createElement("span");
            label.classList.add("clash-td-ellipsis");
            label.textContent = `${installation.category}: ${installation.name}`;

            

            wrapper.appendChild(checkbox);
            wrapper.appendChild(label);
            cell.appendChild(wrapper);
            row.appendChild(cell);

            row.addEventListener("click", (event) => {
                if (event.target.tagName.toLowerCase() !== "input") {
                    console.log("Clicked installation:", installation);
                    console.log("Associated clash:", clash);
                    // Example usage
                    handleElementSelect(experience, installation.mesh);
                }
            });

            installationContainer.appendChild(row);
        });

        tableBody.appendChild(installationContainer);

        // Expand/collapse logic
        toggleButton.addEventListener("click", () => {
            const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
            toggleButton.setAttribute("aria-expanded", String(!isExpanded));
            toggleButton.querySelector(".clasharrow-icon").innerHTML = isExpanded ? "&#9654;" : "&#9660;";
            installationContainer.style.display = isExpanded ? "none" : "";

            document.querySelectorAll(".clashcollapse-toggle").forEach(btn => {
                if (btn !== toggleButton) 
                    {
                        btn.classList.remove("clashcollapse-active");
                    
                    }

            });

            toggleButton.classList.toggle("clashcollapse-active", !isExpanded);

            if (isExpanded) {
                handleElementDeselect(experience, construction.mesh);
                //console.log(experience.world.world.scene.three[2]);
                //console.log(experience.world.world.scene.three);
                asyncFitOrthoPerCameraToCenteredObject(experience.world.world.camera, experience.world.world.scene.three.children[2]);
            } else {
                handleElementSelect(experience, construction.mesh);
                setMeshOpacity(construction.mesh, 0.8)
            }

            //Threejsfunctions.fitOrthoPerCameraToCenteredObject(experience.world.world.camera, construction.mesh);
        });

        // Magnify logic
        toggleButton.querySelector('.magnify-icon').addEventListener('click', (e) => {
            const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
            toggleButton.setAttribute("aria-expanded", String(!isExpanded));
            toggleButton.querySelector(".clasharrow-icon").innerHTML = isExpanded ? "&#9654;" : "&#9660;";
            installationContainer.style.display = isExpanded ? "none" : "";

            document.querySelectorAll(".clashcollapse-toggle").forEach(btn => {
                if (btn !== toggleButton) btn.classList.remove("clashcollapse-active");
            });

            toggleButton.classList.toggle("clashcollapse-active", !isExpanded);


            e.stopPropagation();
            onMagnifyClick(construction, installations, scene);
        });
    });
}
